import { PasswordInput, PasswordValidationTypography, toast } from '@livable/saas-react-components';
import { Button, Grid } from '@mui/material';
import { useFormik } from 'formik';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { beforeSubmitDataValidation } from 'src/core/services/beforeSubmitDataValidation';
import { useStore } from 'src/stores';
import { PASSWORD_REQUIRED_ERROR, PASSWORD_RULES_ERROR } from 'src/utils/formValidation/SignUp';
import { updatePasswordInitialValues, resetPasswordSetSchema } from 'src/utils/formValidation/UpdatePassword';
import useStyles from './styles';
export const ChangePassword = observer(props => {
  const onSuccess = props.onSuccess;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const formik = useFormik({
    initialValues: updatePasswordInitialValues,
    validationSchema: resetPasswordSetSchema,
    onSubmit: async values => {
      const resp = await store.account.updatePasswordAsync.run(beforeSubmitDataValidation({
        oldPassword: values.oldPassword,
        password: values.newPassword
      }));
      if (resp && resp.isSuccessful) {
        formik.resetForm();
        toast('success', {
          body: [t('profile_settings.pass_changed')]
        });
        onSuccess === null || onSuccess === void 0 || onSuccess();
      }
    }
  });
  const handleBlur = e => {
    if (e.target.value) formik.handleBlur(e);
  };
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: formik.handleSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.rules
  }, /*#__PURE__*/React.createElement(PasswordValidationTypography, {
    isInvalid: formik.errors.newPassword === PASSWORD_REQUIRED_ERROR || formik.values.newPassword.trim().length < 8,
    isValidated: formik.touched.newPassword,
    title: t('errors.password_validation_length')
  }), /*#__PURE__*/React.createElement(PasswordValidationTypography, {
    isInvalid: formik.errors.newPassword === PASSWORD_REQUIRED_ERROR || formik.errors.newPassword === PASSWORD_RULES_ERROR,
    isValidated: formik.touched.newPassword,
    title: t('errors.password_validation_chars')
  }), /*#__PURE__*/React.createElement(PasswordValidationTypography, {
    isInvalid: !!formik.errors.repNewPassword,
    isValidated: formik.touched.repNewPassword,
    title: t('errors.password_validation_match')
  }), /*#__PURE__*/React.createElement(PasswordValidationTypography, {
    isValidated: formik.touched.newPassword,
    title: t('profile_settings.pass_rule_three')
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.fields
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(PasswordInput, {
    id: "oldPassword",
    label: t('profile_settings.enter_old_password'),
    error: formik.touched.oldPassword && !!formik.errors.oldPassword,
    name: "oldPassword",
    onBlur: handleBlur,
    onChange: formik.handleChange,
    value: formik.values.oldPassword
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(PasswordInput, {
    error: formik.touched.newPassword && !!formik.errors.newPassword,
    id: "newPassword",
    label: t('profile_settings.new_password'),
    name: "newPassword",
    onBlur: handleBlur,
    onChange: formik.handleChange,
    value: formik.values.newPassword
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(PasswordInput, {
    error: formik.touched.repNewPassword && !!formik.errors.repNewPassword,
    id: "repNewPassword",
    label: t('profile_settings.repeat_new_password'),
    name: "repNewPassword",
    onBlur: handleBlur,
    onChange: formik.handleChange,
    value: formik.values.repNewPassword
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.footer
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: !formik.isValid || !Object.keys(formik.touched).length || store.account.updatePasswordAsync.inProgress,
    type: "submit",
    variant: "priority",
    'custom-attribute': '733-personal-details-page'
  }, t('buttons.save_changes'))));
});